import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Spin,
  Select,
  DatePicker,
  type DatePickerProps,
} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { type AppDispatch } from '../../../redux/store';
import { createInvestmentAction } from '../store/investmentActions';
import { type Investment } from '../store/investmentTypes';
import { type Dayjs } from 'dayjs';

export default function InvestmentIndex(): JSX.Element {
  const dispatch = useDispatch<AppDispatch>();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [branchOptions, setBranchOptions] = useState<
    Array<{
      label: string;
      value: string;
    }>
  >([]);

  const [amount, setAmount] = useState<number>(0);

  useEffect(() => {
    const branches = localStorage.getItem('branches');
    if (branches != null) {
      const parsedBranches = JSON.parse(branches);
      const branchOptionTemp: Array<{ label: string; value: string }> =
        parsedBranches.map((branch: { code: string; id: string }) => ({
          label: branch.code,
          value: branch.id,
        }));
      setBranchOptions(branchOptionTemp);
    }
  }, []);

  // const { deposit }: any = useSelector<any>((state) => state?.deposit);

  // const [onlineAmount, setOnlineAmount] = useState<number>(0);
  // const [offlineAmount, setOfflineAmount] = useState<number>(0);
  // const [investedBy, setInvestedBy] = useState<string>('');

  const [form] = Form.useForm();
  // const [branch, setBranch] = useState('');

  // form.setFieldsValue({ Branch: branch });

  // const getDepositValues = async (): Promise<void> => {
  //   await getDepositAction(dispatch, { branch: 'Krr' });
  // };

  // useEffect(() => {
  //   void getDepositValues();
  // }, []);

  const onFinish = async (values: Investment) => {
    setIsLoading(true);
    const action = createInvestmentAction;
    const response = await action(dispatch, {
      ...values,
      amount,
    });
    setIsLoading(false);
    if (response !== null) {
      form.resetFields();
      setAmount(0);
      setDatePickerDate(null);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const [datePickerDate, setDatePickerDate] = useState<Dayjs | null>(null);

  const onChangeDate: DatePickerProps['onChange'] = (
    date: Dayjs | null,
    dateString: string
  ): void => {
    form.setFieldsValue({ transactionDate: dateString });
    // setDob(dateString);
    setDatePickerDate(date);
  };

  return (
    <div className="investment__page">
      <h1>Investment/Withdrawal Form</h1>
      <Form
        form={form}
        name="deposit_form"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
      >
        <Spin spinning={isLoading} fullscreen />
        <div className="deposit__form">
          <Form.Item
            name="branch"
            rules={[{ required: true, message: 'Please select branch!' }]}
          >
            <div className="customers__input__container">
              <h4>Branch</h4>
              <Select
                // defaultValue={branch}
                onChange={(value: string): void => {
                  form.setFieldsValue({ branch: value });
                  // setBranch(value);
                }}
                style={{ width: 311 }}
                placeholder="Select branch"
                options={branchOptions}
                className="deposit__input"
              />
            </div>
          </Form.Item>

          <Form.Item
            name="investedBy"
            rules={[{ required: true, message: 'Please enter name!' }]}
          >
            <div>
              <h4>Invested/Withdrawal By</h4>
              <Input className="deposit__input" placeholder="Invested By" />
            </div>
          </Form.Item>
          <Form.Item
            name="transactionDate"
            rules={[
              { required: true, message: 'Please select transaction date' },
            ]}
          >
            <div>
              <h4>Transaction Date</h4>
              <DatePicker
                value={datePickerDate}
                onChange={onChangeDate}
                className="deposit__input"
              />
            </div>
          </Form.Item>
          {/* <Form.Item
            name="amount"
            rules={[{ required: true, message: 'Please enter amount' }]}
          > */}
          <div>
            <h4>Amount</h4>
            <Input
              type="number"
              onWheel={(e) => {
                e.currentTarget.blur();
              }}
              disabled
              value={amount}
              className="deposit__input"
              placeholder="Enter amount"
            />
          </div>
          {/* </Form.Item> */}
          <Form.Item
            name="offlineAmount"
            rules={[{ required: true, message: 'Please enter offline amount' }]}
          >
            <div>
              <h4>Offline amount</h4>
              <Input
                type="number"
                onWheel={(e) => {
                  e.currentTarget.blur();
                }}
                onChange={(e) => {
                  setAmount(
                    Number(e.target.value) +
                      Number(form.getFieldValue('onlineAmount') ?? 0)
                  );
                }}
                className="deposit__input"
                placeholder="Enter offline amount"
              />
            </div>
          </Form.Item>
          <Form.Item
            name="onlineAmount"
            rules={[{ required: true, message: 'Please enter offline amount' }]}
          >
            <div>
              <h4>Online amount</h4>
              <Input
                type="number"
                onWheel={(e) => {
                  e.currentTarget.blur();
                }}
                onChange={(e) => {
                  setAmount(
                    Number(e.target.value) +
                      Number(form.getFieldValue('offlineAmount') ?? 0)
                  );
                }}
                className="deposit__input"
                placeholder="Enter online amount"
              />
            </div>
          </Form.Item>
          <Form.Item
            name="type"
            rules={[{ required: true, message: 'Please select type!' }]}
          >
            <div className="customers__input__container">
              <h4>Type</h4>
              <Select
                // defaultValue={branch}
                onChange={(value: string): void => {
                  form.setFieldsValue({ type: value });
                  // setBranch(value);
                }}
                style={{ width: 311 }}
                placeholder="Select type"
                options={[
                  { label: 'Investment', value: 'Investment' },
                  { label: 'Withdrawal', value: 'Withdrawal' },
                  { label: 'Suspense', value: 'Suspense' },
                ]}
                className="deposit__input"
              />
            </div>
          </Form.Item>
          <Form.Item name="investmentType">
            <div className="customers__input__container">
              <h4>Investment Type</h4>
              <Select
                onChange={(value: string): void => {
                  form.setFieldsValue({ investmentType: value });
                }}
                style={{ width: 311 }}
                placeholder="Select investment type"
                options={[
                  { label: 'Personal Loan', value: 'Personal Loan' },
                  {
                    label: 'Personal Loan Interest',
                    value: 'Personal Loan Interest',
                  },
                  { label: 'Gold Sales', value: 'Gold Sales' },
                  { label: 'Site', value: 'Site' },
                  { label: 'Others', value: 'Others' },
                  { label: 'Cash Deposit', value: 'Cash Deposit' },
                  { label: 'Owner', value: 'Owner' },
                  { label: 'Unsecured Loan', value: 'Unsecured Loan' },
                  { label: 'Chit', value: 'Chit' },
                ]}
                className="deposit__input"
              />
            </div>
          </Form.Item>
        </div>

        <Button htmlType="submit" className="deposit__save__button">
          {isLoading ? (
            <Spin
              indicator={
                <LoadingOutlined
                  style={{ fontSize: 24, color: 'white' }}
                  spin
                />
              }
            />
          ) : (
            <span>Submit</span>
          )}
        </Button>
      </Form>
    </div>
  );
}
